// This file will check the schedule of the instructors to see if there are any conflicts between the sessions.
import $ from 'jquery';

interface Session {
    instructor: string;
    dates: {
        startDate: string;
        endDate: string;
    };
    startTime: string;
    endTime: string;
}

function formatDateTime(date: string, time: string): number {
    const formattedDate = new Date(date).toLocaleDateString('en-CA');
    const formattedTime = new Date(time).toLocaleTimeString('en-CA', {
        hour12: false
    });

    return new Date(`${formattedDate}T${formattedTime}`).getTime();
}

function isStartAOverlapping(startA: number, endB: number, startB: number): boolean {
    return startA < endB && startA >= startB;
}

function isStartBOverlapping(startB: number, endA: number, startA: number): boolean {
    return startB < endA && startB >= startA;
}

function isOverlapping(startA: number, endA: number, startB: number, endB: number): boolean {
    return isStartAOverlapping(startA, endB, startB) || isStartBOverlapping(startB, endA, startA);
}

function hasTimeConflict(sessionA: Session, sessionB: Session): boolean {
    const startA = formatDateTime(sessionA.dates.startDate, sessionA.startTime);
    const endA = formatDateTime(sessionA.dates.endDate, sessionA.endTime);
    const startB = formatDateTime(sessionB.dates.startDate, sessionB.startTime);
    const endB = formatDateTime(sessionB.dates.endDate, sessionB.endTime);

    return isOverlapping(startA, endA, startB, endB);
}

function findConflicts(sessions: Session[], sessionKeys: string[]): string[] {
    const conflicts = [] as string[];

    sessions.forEach((sessionA, i) => {
        sessions.slice(i + 1).forEach((sessionB, j) => {
            const sessionKeyA = sessionKeys[i];
            const sessionKeyB = sessionKeys[i + 1 + j];

            if (sessionA.instructor === sessionB.instructor && hasTimeConflict(sessionA, sessionB)) {
                const highlightTagA = $(`[class*=${sessionKeyA}-grid]`);
                const highlightTagB = $(`[class*=${sessionKeyB}-grid]`);

                highlightTagA.addClass('highlight');
                highlightTagB.addClass('highlight');
                conflicts.push(`Conflict found between ${sessionKeyA} and ${sessionKeyB}`);
            }
        });
    });

    return conflicts;
}

export function checkInstructorScheduleConflicts(classSessions: any): string[] {
    const sessions = Object.values(classSessions) as Session[];
    const sessionKeys = Object.keys(classSessions);

    return findConflicts(sessions, sessionKeys);
}

const HOURS_IN_HALF_DAY = 12;
const MIDNIGHT_HOUR = 0;

export const convertTo24HourFormat = (time: any): string => {
    const [timePart, modifier] = time.split(' ');
    const [hours, minutes] = timePart.split(':');
    const convertedHours = (hours === '12' ? MIDNIGHT_HOUR : parseInt(hours, 10)) + (modifier === 'PM' ? HOURS_IN_HALF_DAY : 0);

    return `${convertedHours.toString().padStart(2, '0')}:${minutes}`;
};

export const isStartTimeLessThanEndTime = (startTime: any, endTime: any): boolean => {
    const startTime24 = convertTo24HourFormat(startTime);
    const endTime24 = convertTo24HourFormat(endTime);

    return startTime24 < endTime24;
};

export const isInvalidDate = (startDate: any, endDate: any): boolean => {
    return startDate === 'aN/aN/N' || endDate === 'aN/aN/N';
};

export const updateSetState = (setState: any): void => {
    setState((prevState: any) => ({
        ...prevState,
        formError: true,
        message: 'Please correct the highlighted fields and try again.',
        showMessage: true
    }));
};

export const highlightInvalidTime = (startTime: any, endTime: any, parentPath: any, setState: any): void => {
    if (!isStartTimeLessThanEndTime(startTime, endTime)) {
        const timeTags = $(`[id*=${parentPath}-startTime], [id*=${parentPath}-endTime]`);

        timeTags.parent().addClass('highlight');
        updateSetState(setState);
    }
    const startDate = $(`[id*=dateRangePickerStart-${parentPath}-dates-startDate]`);
    const endDate = $(`[id*=dateRangePickerEnd-${parentPath}-dates-startDate]`);

    if (isInvalidDate(startDate.val(), endDate.val())) {
        startDate.parent().addClass('highlight');
        endDate.parent().addClass('highlight');
        updateSetState(setState);
    }
};
